import styled from "styled-components";

export const ModalStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

export const ModalMain = styled.div`
  position: fixed;
  background: white;
  max-width: 100%;
  width: auto !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
`;

export const ModalButtonCloseDiv = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
  min-height: 45px;
`;

export const ModalButtonClose = styled.button`
  border: 1px solid #f82431;
  background-color: transparent;
  margin: 10px;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  font-size: 20px;
  color: #f82431;
  cursor: pointer;
`;

export const ModalTitle = styled.h3`
  font-size: 24px;
  margin: 10px 10px 10px 20px;
`;

export const ModalContainer = styled.div`
  width: auto !important;
  max-width: 100%;
  overflow-y: auto;
  border: 1px solid white;
`;
